// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MorePosts__posts":"pe_a bho_rc bho_qx bho_xr"};